"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var MediaLibrary_module_css_1 = __importDefault(require("./MediaLibrary.module.css"));
var getDialogStyles = function (mediaType) {
    var width = "auto";
    var maxWidth = "80%";
    var maxHeight = "80%";
    if (mediaType.includes("video")) {
        maxWidth = "40%";
    }
    else if (mediaType.includes("image")) {
        maxWidth = "60%";
    }
    else if (mediaType.includes("application")) {
        width = "90vw";
        maxHeight = "90vh";
    }
    return {
        "& .MuiDialog-paper": {
            overflow: "visible",
            borderRadius: "14px",
            background: "transparent",
            padding: 0,
            width: width,
            maxWidth: maxWidth,
            maxHeight: maxHeight,
        },
        "& .MuiDialogContent-root": {
            padding: 0,
            overflow: "visible",
        }
    };
};
var MediaPreviewModal = function (_a) {
    var isShown = _a.isShown, toggle = _a.toggle, url = _a.url, mediaType = _a.mediaType;
    var isSvg = mediaType === "image/svg+xml";
    return (react_1.default.createElement(material_1.Dialog, { open: isShown, onClose: toggle, sx: getDialogStyles(mediaType), "data-cy": "media-library-popup" },
        react_1.default.createElement(material_1.IconButton, { "aria-label": "close", onClick: toggle, sx: {
                background: "var(--close-btn-color)",
                borderRadius: "50%",
                width: "42px",
                height: "42px",
                fontSize: "24px",
                cursor: "pointer",
                position: "absolute",
                right: -21,
                top: -21,
                zIndex: 10,
                "&:hover": {
                    background: "var(--close-btn-color)",
                },
            } },
            react_1.default.createElement("div", { "data-cy": "modalCloseBtn" },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faXmark, style: { color: "var(--info-color)" } }))),
        react_1.default.createElement(material_1.Fade, { in: isShown, timeout: 500 },
            react_1.default.createElement(material_1.DialogContent, null,
                react_1.default.createElement("div", { className: MediaLibrary_module_css_1.default["preview-content"] },
                    mediaType.includes("video") && (react_1.default.createElement("video", { src: url, autoPlay: true, controls: true, className: MediaLibrary_module_css_1.default["preview-video"] })),
                    mediaType.includes("image") && !isSvg && (react_1.default.createElement("img", { src: url, alt: "Preview", className: MediaLibrary_module_css_1.default["preview-image"] })),
                    isSvg && (react_1.default.createElement("object", { data: url, type: "image/svg+xml", className: MediaLibrary_module_css_1.default["preview-image"] })),
                    mediaType.includes("application") && !isSvg && (react_1.default.createElement("iframe", { src: url, className: MediaLibrary_module_css_1.default["preview-iframe"], style: { border: "none" } })))))));
};
exports.default = MediaPreviewModal;
